import { ComponentRoute } from '@/classes'

const JobInvoicedRoutes = {
  JobInvoicedView: new ComponentRoute('/jobinvoiced', 'JobInvoicedView')
}

export default JobInvoicedRoutes